class DropdownMenu extends HTMLElement {
  constructor() {
    super();

    const openDropdownBtn = this.querySelector('[data-open-dropdown]');
    const dropdownMenu = this.querySelector('[data-dropdown-menu]');
    const dropdownOptions = this.querySelectorAll('[data-dropdown-option]');
    const dropdownText = this.querySelector('[data-dropdown-text]');

    openDropdownBtn.addEventListener('click', () => {
      dropdownMenu.classList.toggle('hidden');
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        dropdownMenu.classList.add('hidden');
      }
    });

    dropdownOptions.forEach((option) => {
      option.addEventListener('click', (e) => {
        dropdownText.textContent = e.target.textContent;

        dropdownOptions.forEach((item) => {
          item.parentElement.classList.remove('bg-[#eee]');
          item.dataset.dropdownOption = '';
        });
        e.target.parentElement.classList.add('bg-[#eee]');
        e.target.dataset.dropdownOption = 'selected';
        dropdownMenu.classList.add('hidden');
      });
    });
  }
}

if (customElements.get('custom-dropdown-menu') === undefined) {
  customElements.define('custom-dropdown-menu', DropdownMenu);
}
